// extracted by mini-css-extract-plugin
export default {"team-settings":"styles_team-settings__6h15o","team-block":"styles_team-block__Kf8PG","block-label":"styles_block-label__IedR8"};